export function CommonNumberFormat(price){
    if(Number.isNaN(parseInt(price))){
        return 0;
    }else{
        return parseInt(price).toLocaleString();
    }
}